<script>
	export let error = undefined;
	export let value = '';
	export let placeholder = "Placeholder";
</script>

<div class="input-group">
	<input class={ value != '' ? 'has-value' : ''} 
				bind:value={value} 
				placeholder="{placeholder}" 
				type="text"
	>
	{#if !!error }
		<span class="error">{error}</span>
	{/if}
</div>

<style lang="scss">
@import '../scss/variables.scss';

input {
	color: black;
	background-color:$lighter-grey;
	border: 2px solid $light-grey;
	height: 50px;
	width: 100%;
	line-height: 50px;
	padding: 5px 10px;
	margin-bottom: 0;
	&.has-value {
		background-color: white;
	}
}

input::placeholder {
	font-weight: 600;
	color: $medium-grey
}

span.error {
	font-size: 12px;
	color: darkred;
}
</style>